export enum DefaultThresholdColor {
  INFO = '#0c4e99',
  WARN = '#fff500',
  ERROR = '#ff0000',
  SUCCESS = '#56a64b',
}
